import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from 'src/app/guards/auth.guard';
import { IsvComponent } from './isv.component';

const routes: Routes = [
    {
        path: ':op',
        component: IsvComponent,
        canActivate: [authGuard]
    }
]

@NgModule({
    imports: [RouterModule.forChild((routes))],
    exports: [RouterModule]
})
export class IsvRoutingModule {
}
